import { CompoundFilterDTO, CompoundFilterId, SearchFilterDTO } from "../..";

const compoundSearchTypes: Record<CompoundFilterId, true> = {
  "planning-applications-id": true,
  "owner-portfolio-id": true,
  "amenities-filter": true,
  "power-id": true,
  "traffic-count-id": true,
  "adopted-roads-id": true,
};

export function isCompoundSearchDTO(filter: SearchFilterDTO): filter is CompoundFilterDTO {
  return filter.id in compoundSearchTypes;
}
